<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道北塔新风阀</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-nb10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB10" class="state-info right-pos sign-container">
                <p class="segment-name">NB10梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNB10" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB7" class="state-info right-pos sign-container">
                <p class="segment-name">NB7梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNB7" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB4" class="state-info right-pos sign-container">
                <p class="segment-name">NB4梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNB4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB1" class="state-info right-pos sign-container">
                <p class="segment-name">NB1梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNB1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ1" class="state-info left-pos sign-container">
                <p class="segment-name">NZ1梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ4" class="state-info left-pos sign-container">
                <p class="segment-name">NZ4梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ7" class="state-info left-pos sign-container">
                <p class="segment-name">NZ7梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ7" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ10" class="state-info left-pos sign-container">
                <p class="segment-name">NZ10梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ10" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ13" class="state-info left-pos sign-container">
                <p class="segment-name">NZ13梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ13" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道北塔排气阀</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-nb12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB12, humidityAllowedMaxNB12) }}
              </div>
              <div :class="errorNB12" class="state-info right-pos sign-container">
                <p class="segment-name">NB12梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB12" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB9" class="state-info right-pos sign-container">
                <p class="segment-name">NB9梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB9" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB6" class="state-info right-pos sign-container">
                <p class="segment-name">NB6梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB6" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB3" class="state-info right-pos sign-container">
                <p class="segment-name">NB3梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-n01">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorN01" class="state-info right-pos sign-container">
                <p class="segment-name">N01梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassN01" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ3" class="state-info left-pos sign-container">
                <p class="segment-name">NZ3梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ6" class="state-info left-pos sign-container">
                <p class="segment-name">NZ6梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ6" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ9" class="state-info left-pos sign-container">
                <p class="segment-name">NZ9梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ9" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ12" class="state-info left-pos sign-container">
                <p class="segment-name">NZ12梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ12" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "airValve",
  data() {
    return {
      loading: true,
      timer: null,

      valveClassNB12: "",
      valveClassNB10: "",
      valveClassNB9: "",
      valveClassNB7: "",
      valveClassNB6: "",
      valveClassNB4: "",
      valveClassNB3: "",
      valveClassNB1: "",
      valveClassN01: "",
      valveClassNZ1: "",
      valveClassNZ3: "",
      valveClassNZ4: "",
      valveClassNZ6: "",
      valveClassNZ7: "",
      valveClassNZ9: "",
      valveClassNZ10: "",
      valveClassNZ12: "",
      valveClassNZ13: "",

      //error
      errorNB12: "",
      errorNB10: "",
      errorNB9: "",
      errorNB7: "",
      errorNB6: "",
      errorNB4: "",
      errorNB3: "",
      errorNB1: "",
      errorN01: "",
      errorNZ1: "",
      errorNZ3: "",
      errorNZ4: "",
      errorNZ6: "",
      errorNZ7: "",
      errorNZ9: "",
      errorNZ10: "",
      errorNZ12: "",
      errorNZ13: "",

      dataNameIdDict: {
        valveClassNB12: "9299e777-54ae-49fb-95cb-2c9cf5485563",
        valveClassNB10: "7ff60659-9ed0-40ce-b262-22b53e199c27",
        valveClassNB9: "37e9511b-524d-46cf-998e-26af95203d15",
        valveClassNB7: "451a1422-23f0-4d45-a94c-a990552763f2",
        valveClassNB6: "be860b56-cc71-4f42-9c4f-872c49d18916",
        valveClassNB4: "bdc8eb1e-ec8b-40e1-a8e7-a66e84fd17a1",
        valveClassNB3: "c7abcab7-4c55-471a-81ca-c535c4d2a978",
        valveClassNB1: "ca65874a-d4f4-4be4-b31d-ca69ef5311ef",
        valveClassN01: "abcca3c2-9024-45c3-917a-95224152db53",
        valveClassNZ1: "0e4c88ad-6dcd-4eb0-8662-5c4b5adc2a08",
        valveClassNZ3: "b83c97db-46bd-47cd-aff1-da68c42ebd21",
        valveClassNZ4: "60273c69-e297-4630-a327-edd66756adfe",
        valveClassNZ6: "7d8b1037-f538-474f-8b5a-26d7ac9f434f",
        valveClassNZ7: "99d2733d-fcc5-4616-a4fe-85126815154d",
        valveClassNZ9: "2932bf8c-ed59-495b-9df5-aac25fe33eee",
        valveClassNZ10: "70b888d9-a214-417e-9793-22f5cf8cba1e",
        valveClassNZ12: "9c4f1b02-ca41-4159-b8b3-d89b5000a32e",
        valveClassNZ13: "1414fd16-929a-4cbc-b398-11f22d98fc19",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxNN1Dehumidifier: "ca13a89c-9a39-4a28-8356-51f58982e30a",
        humidityAllowedMaxNN2Dehumidifier: "764709cd-f38e-410d-93c6-4e6d402919c1",
        humidityAllowedMaxNN3Dehumidifier: "4cc3af06-4e3e-4daa-8dbe-f019ae49a73d",
        humidityAllowedMaxNN4Dehumidifier: "b288e941-56f5-45e5-b0d0-1cb6f25f3a50",
        humidityAllowedMaxNT1Dehumidifier: "16198424-bc59-4d5c-aabb-031cb783288d",
        humidityAllowedMaxN04: "bf13765e-b024-42e6-8c0f-f1656945096f",
        humidityAllowedMaxNB12: "b617c5e1-7bef-464f-962f-ff9714ac004a",
        humidityAllowedMaxNB8: "eefa73f3-2030-445d-9fdd-29e0edab2d55",
        humidityAllowedMaxNB5: "10ade259-104c-487a-b3d7-33227ffb5005",
        humidityAllowedMaxNB2: "f66f9d29-20a5-4ad5-a5d1-0c2931db7832",
        humidityAllowedMaxNZ1: "1201b049-777d-4337-bd8d-0cb9b970c15e",
        humidityAllowedMaxNZ5: "0a09b5b0-8441-4218-b9ad-5850f64a83a5",
        humidityAllowedMaxNZ8: "47fb3abe-699f-4827-bbe6-d36913b94e1b",
        humidityAllowedMaxNZ11: "cde0f349-2ba2-4b21-abc6-b52d0bd576c2",
        humidityAllowedMaxT1: "e6a9e99e-55df-44ad-aa16-e2f8dbf0e7ec",
        humidityAllowedMaxT2: "d5da7010-7036-49dd-b0cd-0908c3199e27",
        humidityAllowedMaxT3: "bcabb070-c6b1-4175-a662-9e7bb499464c",
        humidityAllowedMaxT4: "ed2c0cbd-6ebb-4918-b06a-795ca6e5016c",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        //humidity, temperature
        humidityNN1Dehumidifier: "errorNN1Dehumidifier",
        humidityNN2Dehumidifier: "errorNN2Dehumidifier",
        humidityNN3Dehumidifier: "errorNN3Dehumidifier",
        humidityNN4Dehumidifier: "errorNN4Dehumidifier",
        humidityNT1Dehumidifier: "errorNT1Dehumidifier",
        temperatureNN1Dehumidifier: "errorNN1Dehumidifier",
        temperatureNN2Dehumidifier: "errorNN2Dehumidifier",
        temperatureNN3Dehumidifier: "errorNN3Dehumidifier",
        temperatureNN4Dehumidifier: "errorNN4Dehumidifier",
        temperatureNT1Dehumidifier: "errorNT1Dehumidifier",

        humidityN04: "errorN04",
        humidityNB12: "errorNB12",
        humidityNB8: "errorNB8",
        humidityNB5: "errorNB5",
        humidityNB2: "errorNB2",
        humidityNZ1: "errorNZ1",
        humidityNZ5: "errorNZ5",
        humidityNZ8: "errorNZ8",
        humidityNZ11: "errorNZ11",
        humidityT1: "errorT1",
        humidityT2: "errorT2",
        humidityT3: "errorT3",
        humidityT4: "errorT4",
        temperatureN04: "errorN04",
        temperatureNB12: "errorNB12",
        temperatureNB8: "errorNB8",
        temperatureNB5: "errorNB5",
        temperatureNB2: "errorNB2",
        temperatureNZ1: "errorNZ1",
        temperatureNZ5: "errorNZ5",
        temperatureNZ8: "errorNZ8",
        temperatureNZ11: "errorNZ11",
        temperatureT1: "errorT1",
        temperatureT2: "errorT2",
        temperatureT3: "errorT3",
        temperatureT4: "errorT4",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierNN1: "errorNN1Dehumidifier",
        malfunctionDehumidifierNN2: "errorNN2Dehumidifier",
        malfunctionDehumidifierNN3: "errorNN3Dehumidifier",
        malfunctionDehumidifierNN4: "errorNN4Dehumidifier",
        malfunctionDehumidifierNT1: "errorNT1Dehumidifier",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityNN1Dehumidifier: "humidityTooltipErrorNN1Dehumidifier",
        humidityNN2Dehumidifier: "humidityTooltipErrorNN2Dehumidifier",
        humidityNN3Dehumidifier: "humidityTooltipErrorNN3Dehumidifier",
        humidityNN4Dehumidifier: "humidityTooltipErrorNN4Dehumidifier",
        humidityNT1Dehumidifier: "humidityTooltipErrorNT1Dehumidifier",
        humidityN04: "humidityTooltipErrorN04",
        humidityNB12: "humidityTooltipErrorNB12",
        humidityNB8: "humidityTooltipErrorNB8",
        humidityNB5: "humidityTooltipErrorNB5",
        humidityNB2: "humidityTooltipErrorNB2",
        humidityNZ1: "humidityTooltipErrorNZ1",
        humidityNZ5: "humidityTooltipErrorNZ5",
        humidityNZ8: "humidityTooltipErrorNZ8",
        humidityNZ11: "humidityTooltipErrorNZ11",
        humidityT1: "humidityTooltipErrorT1",
        humidityT2: "humidityTooltipErrorT2",
        humidityT3: "humidityTooltipErrorT3",
        humidityT4: "humidityTooltipErrorT4",
      },

      // //running -> running tool tip
      // dataNameRunningTooltipNameDict: {
      //   runningDehumidifierNN1: "runningTooltipNN1",
      //   runningDehumidifierNN2: "runningTooltipNN2",
      //   runningDehumidifierNN3: "runningTooltipNN3",
      //   runningDehumidifierNN4: "runningTooltipNN4",
      //   runningDehumidifierNT1: "runningTooltipNT1",
      // },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierNN1: "runningClassNN1",
        runningDehumidifierNN2: "runningClassNN2",
        runningDehumidifierNN3: "runningClassNN3",
        runningDehumidifierNN4: "runningClassNN4",
        runningDehumidifierNT1: "runningClassNT1",
      },
      stationIdList: ["5d3d3f64-cae8-4216-8fda-cd38c3cbcf1e", "17790481-8c80-4615-9a98-b844013ac9e9"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-valve-sign-default {
  0% {
    background-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    background-color: #ffff00;
  }
}
@keyframes breathee-remote-in-progress {
  0% {
    border-color: rgba(075, 160, 240, 0.3);
  }
  100% {
    border-color: #4ba0f0;
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/hangzhouwan/bridgeLine_north.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 255px;
          left: 335px;
        }

        .station-block-right {
          top: 255px;
          left: 843px;
        }

        .station-block-tower {
          top: 230px;
          left: 586px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            & .segment-name {
              font-size: 25px;
              margin-bottom: 4px;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .sta-left-left {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-left-right {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-left {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-right {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-tower {
          top: 230px;
          left: 590px;
          &::before {
            bottom: 7px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 24px;
            left: -40px;
          }
          .state-info {
            right: 40px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .valve-sign {
          margin-top: auto;
          margin-bottom: auto;
          width: 12px;
          height: 12px;
          background-color: #ffff00;
          animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
          border-radius: 10px;

          &.open {
            background-color: #67dd34;
            animation: none;
          }
          &.closed {
            background-color: #a0a0a0;
            animation: none;
          }
          &.switching {
            background-color: #4ba0f0;
            animation: none;
          }
        }

        .sign-container {
          & > p {
            margin: 0;
            white-space: nowrap;
            white-space: nowrap;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            &:first-child {
              font-size: 13px;
            }
          }
        }

        .sensor-nb12 {
          top: 260px;
          left: 175px;
          &::before {
            bottom: 60px;
            left: -81px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -65px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            min-width: 95px;
          }
        }

        .sensor-nb10 {
          top: 260px;
          left: 241px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb9 {
          top: 260px;
          left: 272px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb7 {
          top: 260px;
          left: 340px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb6 {
          top: 260px;
          left: 370px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb4 {
          top: 260px;
          left: 437px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb3 {
          top: 260px;
          left: 468px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb1 {
          top: 260px;
          left: 536px;
          &::before {
            bottom: 130px;
            left: -129px;
            width: 250px;
            transform: rotate(85deg);
          }
          &::after {
            bottom: 254px;
            left: -29px;
          }
          .state-info {
            right: 45px;
            top: -239px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-n01 {
          top: 260px;
          left: 590px;
          &::before {
            bottom: 130px;
            left: -129px;
            width: 250px;
            transform: rotate(85deg);
          }
          &::after {
            bottom: 254px;
            left: -29px;
          }
          .state-info {
            right: 45px;
            top: -239px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz1 {
          top: 260px;
          left: 643px;
          &::before {
            bottom: 130px;
            left: -105px;
            width: 250px;
            transform: rotate(95deg);
          }
          &::after {
            bottom: 254px;
            left: 30px;
          }
          .state-info {
            right: -125px;
            top: -239px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz3 {
          top: 260px;
          left: 710px;
          &::before {
            bottom: 122px;
            left: -80px;
            width: 240px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 238px;
            left: 70px;
          }
          .state-info {
            right: -165px;
            top: -223px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz4 {
          top: 260px;
          left: 742px;
          &::before {
            bottom: 122px;
            left: -80px;
            width: 240px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 238px;
            left: 70px;
          }
          .state-info {
            right: -165px;
            top: -223px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz6 {
          top: 260px;
          left: 810px;
          &::before {
            bottom: 105px;
            left: -62px;
            width: 210px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 204px;
            left: 78px;
          }
          .state-info {
            right: -173px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz7 {
          top: 260px;
          left: 846px;
          &::before {
            bottom: 105px;
            left: -62px;
            width: 210px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 204px;
            left: 78px;
          }
          .state-info {
            right: -173px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz9 {
          top: 260px;
          left: 914px;
          &::before {
            bottom: 89px;
            left: -42px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 171px;
            left: 100px;
          }
          .state-info {
            right: -194px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz10 {
          top: 260px;
          left: 946px;
          &::before {
            bottom: 89px;
            left: -42px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 171px;
            left: 100px;
          }
          .state-info {
            right: -194px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz12 {
          top: 260px;
          left: 1015px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 67px;
          }
          .state-info {
            right: -161px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz13 {
          top: 260px;
          left: 1050px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 67px;
          }
          .state-info {
            right: -161px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-t4 {
          top: 30px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t3 {
          top: 80px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t2 {
          top: 130px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t1 {
          top: 180px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>